var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zrss-header"},[_vm._t("default",[_c('div',{staticClass:"text-h5"},[_vm._v("Prijavnica za svetovanje")])]),_c('a',{attrs:{"href":"http://zrss.si/"}},[_c('logo')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }